module.exports = __webpack_public_path__ + "img/ec9fe23.jpg";